'use strict';

var React = require('react');

var SvgJobsFilledMajor = function SvgJobsFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.5 4.75v.75h-.5a3 3 0 0 0-2.967 2.555.748.748 0 0 1 .234.152l.002.001.014.014.074.064c.068.058.175.145.319.251.288.213.724.503 1.298.794 1.147.582 2.844 1.169 5.026 1.169 2.181 0 3.878-.587 5.026-1.169a9.19 9.19 0 0 0 1.298-.794 6.039 6.039 0 0 0 .392-.315l.016-.014v-.001a.747.747 0 0 1 .235-.152 3 3 0 0 0-2.967-2.555h-.5v-.75a1.75 1.75 0 0 0-1.75-1.75h-3.5a1.75 1.75 0 0 0-1.75 1.75Zm1.75-.25a.25.25 0 0 0-.25.25v.75h4v-.75a.25.25 0 0 0-.25-.25h-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9.898c-.33.23-.763.5-1.296.77a12.428 12.428 0 0 1-4.704 1.295v.037a1 1 0 1 1-2 0v-.037a12.428 12.428 0 0 1-4.704-1.294 10.92 10.92 0 0 1-1.296-.77v4.101a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-4.102Z"
  }));
};
SvgJobsFilledMajor.displayName = "JobsFilledMajor";

exports.SvgJobsFilledMajor = SvgJobsFilledMajor;
